import {

  ALLOWED_EXTENSIONS,

  MAX_FILE_SIZE_BYTES,

  MAX_DOCUMENTS,

} from '@/features/shipment/types/documentType';

/**

 * Get the lowercase file extension from a filename.

 */

export function getFileExtension(fileName: string): string {
  const parts = fileName.split('.');

  if (parts.length < 2) return '';

  return (parts.pop() || '').toLowerCase();
}

/**

 * Return the appropriate MDI icon name based on file extension.

 * PDF files get a PDF icon; all other allowed types get an image icon.

 */

export function getFileIcon(fileName: string): string {
  const ext = getFileExtension(fileName);

  if (ext === 'pdf') {
    return 'mdi-file-pdf-box';
  }

  return 'mdi-file-image';
}

/**

 * Validate a file before upload.

 * Returns { valid: true } or { valid: false, errorKey } where errorKey

 * is an i18n key under "documents.errorMessages.*".

 */

export function validateFile(

  file: File,

  currentDocumentCount: number,

): { valid: boolean; errorKey: string } {
  if (currentDocumentCount >= MAX_DOCUMENTS) {
    return { valid: false, errorKey: 'documents.maxDocumentsReached' };
  }

  const extension = getFileExtension(file.name);

  if (!ALLOWED_EXTENSIONS.includes(extension)) {
    return { valid: false, errorKey: 'documents.errorMessages.invalidFileType' };
  }

  if (file.size > MAX_FILE_SIZE_BYTES) {
    return { valid: false, errorKey: 'documents.errorMessages.fileTooLarge' };
  }

  return { valid: true, errorKey: '' };
}

/**

 * Map a backend failedReason code to its i18n key.

 * Falls back to a generic upload-failed message for unknown codes.

 */

const FAILED_REASON_MAP: Record<string, string> = {

  FILE_TOO_LARGE: 'documents.failedReasons.FILE_TOO_LARGE',

  INVALID_FILE_TYPE: 'documents.failedReasons.INVALID_FILE_TYPE',

  MIME_MISMATCH: 'documents.failedReasons.MIME_MISMATCH',

  ENCRYPTED_PDF: 'documents.failedReasons.ENCRYPTED_PDF',

  MALWARE_DETECTED: 'documents.failedReasons.MALWARE_DETECTED',

  SCAN_TIMEOUT: 'documents.failedReasons.SCAN_TIMEOUT',

};

export function mapFailedReason(reason: string): string {
  return FAILED_REASON_MAP[reason] || 'documents.errorMessages.uploadFailed';
}
